;(function($){
'use strict';
/* ==========================================================================
 *
 * タブユーザーインターフェースクラス
 *
 * global namespace: MY_PROJECT
 *
========================================================================== */
/* name space init
-------------------------------------*/
window.MY_PROJECT = window.MY_PROJECT || {};

/* constructor
---------------------------------------------- */
function fixedNav(){
	let _ = this;

	// オプション
	_.config = {
		exec: true,
		scrollLock: true,

		prefix: 'build-',
		targetAttribute: 'fixed-nav',
		bodyClass: 'fixed-nav--open',
	};

	_.init();
};

/* ----------------------------------------------
 * init
 * @ :
 * return :
---------------------------------------------- */
fixedNav.prototype.init = function(){
	let _ = this;

	_.start();
};

/* start
 * @string:
 * return array = hash strings array
---------------------------------------------- */
fixedNav.prototype.start = function($group){
	let _ = this;

	let nav = {};

	$(document).on('ready',function(){
		if(_.config.scrollLock){
			// 必要スタイルの追記
			const scrollLockStyle = `
<style>
.scrollLock{
	position: fixed;
	width: 100%;
}
</style>
			`;
			$('head').append(scrollLockStyle);
		}

		// DOMの確保
		nav.trigger = $('*[' + _.config.targetAttribute + '="trigger"]');
		nav.menu = $('*[' + _.config.targetAttribute + '="menu"]');

		// メニューの初期展開確認
		nav.expanded = nav.trigger.attr('aria-expanded');
		if(!nav.expanded){
			nav.expanded = false;
			nav.trigger.attr('aria-expanded',false);
		}

		nav.trigger.on('click',function(e){
			e.preventDefault();

			// 展開時の動作
			if(nav.trigger.attr('aria-expanded') === 'true'){
				$('body').removeClass(_.config.bodyClass);
				nav.trigger.attr('aria-expanded',false);

				if(_.config.scrollLock){
					$('body').removeClass('scrollLock');
					$('html, body').prop({scrollTop: this.scrollLockTop});
				};

			// 非展開時の操作
			}else{
				$('body').addClass(_.config.bodyClass);
				nav.trigger.attr('aria-expanded',true);

				if(_.config.scrollLock){
					this.scrollLockTop = $(window).scrollTop();
					$('body').addClass('scrollLock');
					$('body').css('top',-1 * this.scrollLockTop);
				};
			};
		});
	});
};

/* ==========================================================================
 * プロジェクトインスタンス生成
========================================================================== */
window.MY_PROJECT.fixedNav = $.extend( true ,new fixedNav(), window.MY_PROJECT.fixedNav );

})(jQuery);
